export default __webpack_public_path__ + "static/media/print.0d47a866.svg";